import React from 'react';
import { LandingPageImage } from '../../assets';
import DemoButton from '../Common/DemoButton';
import './LandingPage.css';

const DEFAULT_TITLE = 'Freight Forwarding Software \nfor Modern Forwarders';
const DEFAULT_SUBTITLE =
  'Streamline your day-to-day operations, boost shipment profits, and delight your customers.';

const LandingPage = ({ title, subtitle, complianceTags }) => {
  const displayTitle = title || DEFAULT_TITLE;

  return (
    <div id="landing-page" className="main-content">
      <div className="landing-section">
        <h1 className="title header-1">
          {displayTitle.split('\n').map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i < displayTitle.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </h1>
        <span className="subtitle body-text-2">
          {subtitle || DEFAULT_SUBTITLE}
        </span>
        {complianceTags?.length > 0 && (
          <div className="lp-compliance-tags">
            {complianceTags.map(tag => (
              <span key={tag} className="lp-compliance-tag">{tag}</span>
            ))}
          </div>
        )}
        <DemoButton size="large" />
      </div>

      <div className="details-section">
        <img
          src={LandingPageImage}
          alt="Shipmnts freight ERP dashboard: shipment management interface"
          className="screenshot"
        />
      </div>
    </div>
  );
};

export default LandingPage;
